import React, {useEffect, useState} from 'react';
import {FiChevronRight, FiHome} from "react-icons/fi";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {getAllCompanies} from "../services/companyService";
import cx from "classnames";
import moment from "moment/moment";

function Company() {

  const {t} = useTranslation();

  const [companies, setCompanies] = useState([]);

  const fetchCompanies = async ()=>{
    try {
      const res = await getAllCompanies();

      if(res){
        setCompanies(res);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchCompanies();
  }, []);

  return (
    <div>
      <div className="text-gray-500 flex items-center gap-2 mt-2 mb-6">
        <span className="text-xs font-semibold flex items-center">
          <FiHome size={12}/> <FiChevronRight size={12}/>
        </span>
        <h4 className="text-xs font-semibold text-gray-500">{t("COMPANY.TITLE")}</h4>
      </div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold">{t("COMPANY.TITLE")}</h1>
        <Link to='/new-partner'
              className="cursor-pointer bg-azure px-4 py-2 text-sm font-semibold rounded-lg text-white hover:opacity-60 hover:shadow">
          {t("COMPANY.ADD_BTN")}
        </Link>
      </div>
      <div className='bg-white p-3 rounded-lg shadow overflow-x-auto'>
        <table className="min-w-full border-collapse" id='my-applications-table'>
          <thead className="bg-gray-100 customShadow">
          <tr>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("COMPANY.TABLE.ADDRESS")}
            </th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("COMPANY.TABLE.COMPANY_NAME")}
            </th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("COMPANY.TABLE.DATE_IN")}
            </th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("GLOBAL.EMAIL")}
            </th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("COMPANY.TABLE.PO_BOX")}
            </th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("GLOBAL.STATUS")}
            </th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("COMPANY.TABLE.WEBSITE")}
            </th>
          </tr>
          </thead>
          <tbody className="text-gray-800 text-sm ">
          {
            companies.map((it) =>
              <tr key={it.Id} className={cx('border')}>
                <td className="text-left py-3 px-2">{it.Address}</td>
                <td className="text-left py-3 px-2">{it.CompanyName}</td>
                <td className="text-left py-3 px-2">{moment(it.Datein).format("DD/MM/yyyy")}</td>
                <td className="text-left py-3 px-2">{it.Email}</td>
                <td className="text-left py-3 px-2">{it.PoBox}</td>
                <td className="text-left py-3 px-2">{it.Status}</td>
                <td className="text-left py-3 px-2">{it.Website}</td>
              </tr>
            )
          }
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Company;
